module.exports = __webpack_public_path__ + "img/icon_login_white.7e1f5209.svg";